<template>
    <div class="exam-list">
        <el-tabs v-model="activeName" class="m-tab">
            <el-tab-pane label="前台用户" name="front">
               <div class="search-container">
                   <el-button
                       v-if="$store.state.isCheckEnd"
                       icon="el-icon-circle-plus"
                       type="success"
                       plain
                       size="medium"
                       @click="Add"
                       style="margin-right: 20px">新增
                   </el-button>
                   <el-button
                       icon="el-icon-upload2"
                       type="warning"
                       plain
                       size="medium"
                       style="margin-right: 20px"
                       @click.stop="importUser">导入用户
                   </el-button>
                  <div style="margin-left: auto; width: 60%" class="xy-start">
                      <el-cascader
                          placeholder="请选择用户组"
                          v-model="OrganLevelID"
                          size="medium"
                          clearable
                          :options="groupData"
                          :props="{label: 'Name', value: 'ID', children: 'children', emitPath: false, checkStrictly: true}"
                          style="margin-right: 20px; width: 45%"
                          @keyup.enter.native="GetOrganUser(true)">
                      </el-cascader>

                      <el-input
                          placeholder="请输入关键字检索..."
                          v-model="keyWord"
                          size="medium"
                          clearable
                          style="margin-right: 20px; width: 45%"
                          @keyup.enter.native="GetOrganUser(true)"></el-input>

                      <el-button
                          type="primary"
                          size="medium"
                          icon="el-icon-search"
                          @click="GetOrganUser(true)">检索
                      </el-button>
                  </div>
               </div>
                <div class="table clearfix">
                    <el-table
                        :data="data"
                        row-key="id"
                        style="width: 100%;"
                        v-loading="loading"
                    >
                        <el-table-column
                            label="用户名"
                            prop="UserName"
                            width="160"
                        />
                        <el-table-column
                            label="真实姓名"
                            prop="RealName"
                            width="160"
                        />
                        <el-table-column
                            label="联系电话"
                            prop="Telephone"
                            align="center"
                            width="140"
                        />
                        <el-table-column
                            label="邮箱"
                            prop="Email"
                            align="center"
                            width="200"
                        />
                        <el-table-column
                            label="用户组"
                            prop="OrganLevelName"
                            :formatter="defaultVal"
                            align="center"
                            width="150"
                        />

                        <el-table-column
                            prop="Flags"
                            label="状态"
                            align="center"
                            width="80"
                            :formatter="stateFormatter"
                        ></el-table-column>

                        <el-table-column
                            prop="UserType"
                            label="来源"
                            align="center"
                            width="80"
                            :formatter="sourceFormatter"
                        ></el-table-column>
                        <el-table-column
                            label="创建时间"
                            prop="CreateTime"
                            align="center"
                            width="160"
                        />
                        <el-table-column
                            label="创建者"
                            prop="CreateName"
                            align="center"
                            width="160"
                        >
                        </el-table-column>

                        <el-table-column
                            label="最近更新时间"
                            prop="ModifyTime"
                            align="center"
                            width="160"
                        >
                        </el-table-column>

                        <el-table-column
                            label="备注"
                            prop="DescInfo"
                            align="left"
                            width="200"
                        >
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            fixed="right"
                            align="center"
                            width="230"
                        >
                            <template #default="{row}">
                                <el-button v-if="$store.state.isCheckEnd" size="mini" @click="Edit(row)"
                                >编辑
                                </el-button
                                >
                                <el-button
                                    type="info"
                                    size="mini"
                                    class="table-btn"
                                    @click="Reset(row)"
                                >重置密码
                                </el-button
                                >
                                <el-button
                                    type="danger"
                                    size="mini"
                                    class="table-btn"
                                    @click="Delete(row)"
                                >删除
                                </el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="xy-center mt-17 mb-10">
                    <el-pagination
                        hide-on-single-page
                        @current-change="GetOrganUser()"
                        @size-change="GetOrganUser(true)"
                        :current-page.sync="pageIndex"
                        :page-size.sync="pageSize"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                    >
                    </el-pagination>
                </div
                >
            </el-tab-pane>
            <el-tab-pane label="用户审核" name="apply">
                <div class="form2">
                    <div class="xy-between">
                        <div class="xy-start">
                            <el-select
                                v-model="stateValue"
                                placeholder="请选择状态"
                                style="margin-right:20px"
                                @change="GetOrganApplyUser(true)"
                            >
                                <el-option
                                    v-for="item in stateOption"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                            <el-input
                                placeholder="请输入关键字检索..."
                                v-model="applyKeyWord"
                                @keyup.enter.native="GetOrganApplyUser"
                            ></el-input>
                            <el-button
                                type="primary"
                                class="ml-10"
                                size="medium"
                                icon="el-icon-search"
                                @click="GetOrganApplyUser(true)"
                            >检索
                            </el-button
                            >
                        </div>
                    </div>
                </div>
                <div class="table">
                    <el-table
                        :data="applyData"
                        style="width: 100%;"
                    >
                        <el-table-column
                            label="用户名"
                            prop="UserName"
                            width="140"
                        />
                        <el-table-column
                            label="真实姓名"
                            prop="RealName"
                            width="120"
                        />
                        <el-table-column
                            label="联系电话"
                            prop="Telephone"
                            align="center"
                            width="120"
                        />

                        <el-table-column
                            prop="State"
                            label="状态"
                            align="center"
                            width="80"
                            :formatter="applyAtateFormatter"
                        ></el-table-column>

                        <el-table-column
                            label="申请机构"
                            prop="ApplyOrganName"
                            align="center"
                            width="200"
                        />
                        <el-table-column
                            label="申请用户组"
                            prop="ApplyLevelName"
                            align="center"
                            width="200"
                        />
                        <el-table-column
                            label="原机构"
                            prop="OrganName"
                            align="center"
                            width="200"
                        />
                        <el-table-column
                            label="原用户组"
                            prop="LevelName"
                            align="center"
                            width="200"
                        />

                        <el-table-column
                            label="操作"
                            fixed="right"
                            align="center"
                            width="170"
                        >
                            <template #default="{row}">
                                <el-button
                                    v-if="row.State === 0"
                                    size="mini"
                                    @click="AuditPass(row)"
                                >审核通过
                                </el-button
                                >
                                <el-button
                                    v-if="row.State === 0"
                                    size="mini"
                                    type="danger"
                                    @click="AuditReject(row)"
                                >驳回
                                </el-button
                                >
                                <span v-if="row.State === 1 || parseInt(row.State) === 2">无操作</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="xy-center mt-17 mb-10">
                    <el-pagination
                        hide-on-single-page
                        @current-change="GetOrganApplyUser()"
                        @size-change="GetOrganApplyUser(true)"
                        :current-page.sync="applyPageIndex"
                        :page-size.sync="applyTageSize"
                        :total="applyTotal"
                        layout="total, sizes, prev, pager, next, jumper"
                    >
                    </el-pagination>
                </div>
            </el-tab-pane>
        </el-tabs>

        <!-- 弹窗 -->
        <el-dialog
            :destroy-on-close="true"
            :close-on-click-modal="false"
            width="760px"
            :title="dialogTitle"
            :visible.sync="userVisible"
            custom-class="m-dialog"
            :lock-scroll="false"
            @close="closeDialog"
        >
            <el-form ref="ruleForm" :rules="rulesForm" size="medium" :model="userForm" label-width="0.5rem">
                <div class="fromflexbox">
                    <el-form-item prop="UserName" label="用户名">
                        <el-input
                            v-model="userForm.UserName"
                            :disabled="accountDisabled"
                            class="dialog-text"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="pwd" v-if="pwdShow">
                        <el-input
                            v-model="userForm.pwd"
                            class="dialog-text"
                        ></el-input>
                    </el-form-item>
                </div>
                <div class="fromflexbox">
                    <el-form-item prop="RealName" label="真实姓名">
                        <el-input
                            v-model="userForm.RealName"
                            class="dialog-text"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="电话">
                        <el-input
                            v-model="userForm.Telephone"
                            class="dialog-text"
                        ></el-input>
                    </el-form-item>
                </div>
                <div class="fromflexbox">
                    <el-form-item label="地址">
                        <el-input
                            v-model="userForm.Address"
                            class="dialog-text"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱">
                        <el-input
                            v-model="userForm.Email"
                            class="dialog-text"
                        ></el-input>
                    </el-form-item>
                </div>

                <div class="fromflexbox">
                    <el-form-item label="身份证号">
                        <el-input
                            v-model="userForm.CardId"
                            class="dialog-text"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="学号">
                        <el-input
                            v-model="userForm.NumberNo"
                            class="dialog-text"
                        ></el-input>
                    </el-form-item>
                </div>
                <div class="fromflexbox">
                    <el-form-item label="所属用户组">
                        <el-cascader
                            v-model="organLeverValue"
                            :options="organLeverData"
                            :props="{ checkStrictly: true, emitPath: false }"
                            clearable
                            class="dialog-text"
                            @change="organLeverChange"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select
                            v-model.number="userForm.Flags"
                            class="dialog-text"
                        >
                            <el-option
                                v-for="item in StateInfoData"
                                :key="item.value"
                                :label="item.name"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </div>

                <el-form-item label="备注">
                    <el-input
                        v-model="userForm.DescInfo"
                        class="dialog-text"
                    ></el-input>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button size="medium" @click="closeDialog">取 消</el-button>
                <el-button size="medium" type="primary" @click="Save('ruleForm')">确 定
                </el-button>
            </div>
        </el-dialog>
        <user-import ref="userDialog" @updateList="onUpdateList"/>
    </div>
</template>

<script>
import {
    GetOrganUser,
    GetOrganApplyUser,
    AddOrganUser,
    EditOrganUser,
    GetOrganLevelInfo,
    DeleteOrganUser,
    AuditUserApplyPass,
    AuditUserApplyReject,
    ResetPassword
} from "@/api/organ";

import { GetOrganGroupInfo } from "@/api/category";

import { sm2Encrypt } from "@/utils/sm2"
import { CommonPage } from "@/mixins/commonData";
import userImport from "./userImport"
import { removeEmptyChildren } from "@/utils";
export default {
    components: { userImport },
    mixins: [CommonPage],
    data() {
        return {
            OrganLevelID: undefined, // 用户组id
            activeName: "front",
            loading: false,
            data: [],
            total: 0,
            pageIndex: 1,
            pageSize: 10,
            keyWord: "",

            applyData: [],
            applyTotal: 0,
            applyPageIndex: 1,
            applyTageSize: 10,
            applyKeyWord: "",

            // 弹框（默认隐藏）
            userVisible: false,
            // 弹框标题
            dialogTitle: "",
            // 是否禁用用户名
            accountDisabled: false,
            // 用户状态
            StateInfoData: [
                {
                    value: 0,
                    name: "正常"
                },
                {
                    value: 1,
                    name: "停用"
                }
            ],
            organLeverData: [],
            // 密码文本框（新增显示、编辑隐藏;默认显示）
            pwdShow: true,
            // 密码
            pwd: "",
            // 机构用户组的值
            organLeverValue: [],
            // 表单
            userForm: {
                ID: "",
                UserName: "",
                UserPass: "",
                RealName: "",
                Telephone: "",
                Email: "",
                Address: "",
                CardId: "",
                NumberNo: "",
                Flags: 0,
                GroupUserId: "",
                OrganLevelId: 0,
                Balance: 0,
                DescInfo: "",
                UserRoleType: 0,
                UserType: 2,
                ImportFlags: -1
            },
            // 表单验证规则
            rulesForm: {
                UserName: [
                    {
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    }
                ],
                pwd: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        max: 20,
                        message: "长度在 6 到 20 个字符",
                        trigger: "blur"
                    }

                ],
                RealName: [
                    {
                        required: true,
                        message: "请输入真实姓名",
                        trigger: "blur"
                    },
                    {
                        min: 2,
                        max: 20,
                        message: "长度在 2 到 20 个字符",
                        trigger: "blur"
                    }
                ]
            },
            stateOption: [
                {
                    value: "-2",
                    label: "全部"
                },
                {
                    value: "0",
                    label: "待审核"
                },
                {
                    value: "1",
                    label: "审核通过"
                },
                {
                    value: "2",
                    label: "审核驳回"
                }
            ],
            stateValue: "0",
            groupData: []
        };
    },
    created() {
        this.GetOrganUser();
        this.GetOrganApplyUser();
        this.GetOrganGroupInfo();
    },
    computed: {},
    methods: {
        onUpdateList () {
            this.GetOrganUser()
        },
        // 获取机构用户信息
        async GetOrganUser(refresh) {
            if (refresh === true) {
                this.pageIndex = 1;
            }
            try {
                this.loading = true;
                const { data } = await GetOrganUser({
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    keyWord: this.keyWord,
                    sortBy: "ModifyTime",
                    sortOrder: "desc",
                    ManageType: 2,
                    OrganLevelID: (this.OrganLevelID || this.OrganLevelID === 0) ? String(this.OrganLevelID) : undefined,
                });
                this.data = data.data;
                this.total = data.count;
            } catch (err) {
                this.$toast("获取失败");
            }
            this.loading = false;
        },
        // 获取机构审核用户信息
        async GetOrganApplyUser(refresh) {
            if (refresh === true) {
                this.applyPageIndex = 1;
            }
            try {
                console.log(this.pageIndex)
                const { data } = await GetOrganApplyUser({
                    pageIndex: this.applyPageIndex,
                    pageSize: this.applyTageSize,
                    KeyWord: this.applyKeyWord,
                    applyState: parseInt(this.stateValue),
                    sortBy: "AuditTime",
                    sortOrder: "desc"
                });
                this.applyData = data.data;
                this.applyTotal = data.count;
            } catch (err) {
                this.$toast("获取失败");
            }
        },
        // 用户状态列格式化
        stateFormatter(row, col) {
            if (row.Flags === 1) {
                return <el-tag type="danger">停用</el-tag>;
            } else {
                return <el-tag type="success">正常</el-tag>;
            }
        },
        // 申请状态列格式化
        applyAtateFormatter(row, col) {
            if (row.State === 0) {
                return <el-tag type="">待审核</el-tag>;
            } else if (row.State === 1) {
                return <el-tag type="success">审核通过</el-tag>;
            } else if (row.State === 2) {
                return <el-tag type="danger">审核驳回</el-tag>;
            } else if (row.State === -1) {
                return <el-tag type="danger">已失效</el-tag>;
            } else {
                return "其它";
            }
        },
        // 来源列格式化
        sourceFormatter(row, col) {
            if (row.UserType === 2) {
                return "PC端";
            } else if (row.UserType === 3) {
                return "移动端";
            } else {
                return "其它";
            }
        },
        // 根据机构id获取用户组信息
        async GetOrganLevelInfo(value) {
            const { data } = await GetOrganLevelInfo({
                organId: value
            });
            if (data.code === 100) {
                console.log(data, "data");
                this.organLeverData = data.data;
            }
        },
        // 获取机构用户组信息
        async GetOrganGroupInfo() {
            try {
                const { data } = await GetOrganGroupInfo();
                removeEmptyChildren(data.data, 'children')
                this.groupData = data.data;
                // this.data.splice(0, 0, { KnowledgePointName: "无", id: "0" })
            } catch (err) {
                this.$toast("获取失败");
            }
        },
        // 打开新增窗口
        Add() {
            this.organLeverValue = []
            this.dialogTitle = "新增用户";
            this.userVisible = true;
            this.accountDisabled = false;
            this.pwdShow = true;
            this.GetOrganLevelInfo();
        },
        // 新增用户
        async AddUser() {
            try {
                const { data } = await AddOrganUser(this.userForm);
                if (data.code === 100) {
                    this.$message({
                        message: data.msg,
                        type: "success"
                    });
                    this.GetOrganUser();
                    this.userVisible = false;
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    });
                }
            } catch (err) {
                this.$message({
                    message: "服务器开小差了",
                    type: "error"
                });
            }
        },
        // 编辑用户
        async EditOrganUser() {
            try {
                const { data } = await EditOrganUser(this.userForm);
                if (data.code === 100) {
                    this.$message({
                        message: data.msg,
                        type: "success"
                    });
                    this.GetOrganUser();
                    this.userVisible = false;
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    });
                }
            } catch (err) {
                this.$message({
                    message: "服务器开小差了",
                    type: "error"
                });
            }
        },
        // 打开编辑窗口
        Edit(row) {
            this.dialogTitle = "编辑用户";

            this.userForm.ID = row.ID;
            this.userForm.UserName = row.UserName;
            this.userForm.RealName = row.RealName;
            this.userForm.Telephone = row.Telephone;
            this.userForm.Email = row.Email;
            this.userForm.Address = row.Address;
            this.userForm.Flags = row.Flags;
            this.userForm.CardId = row.CardId;
            this.userForm.NumberNo = row.NumberNo;
            this.userForm.Balance = row.Balance;
            this.userForm.DescInfo = row.DescInfo;
            this.userForm.GroupUserId = row.GroupUserId;
            this.userForm.OrganLevelId = row.OrganLevelId;
            this.userForm.UserRoleType = row.UserRoleType;
            this.organLeverValue = row.OrganLevelId
            this.userVisible = true;
            this.pwdShow = false;
            this.accountDisabled = true;
            this.GetOrganLevelInfo();
        },
        // 保存
        async Save(ruleForm) {
            // this.$refs.ruleForm.validate()
            this.$refs[ruleForm].validate((valid) => {
                if (valid) {
                    if (!this.userForm.ID) {
                        this.userForm.UserPass = sm2Encrypt(this.userForm.pwd);
                        this.AddUser();
                    } else {
                        this.EditOrganUser(this.userForm);
                    }
                } else {
                    // console.log("error submit!!");
                    return false;
                }
            });
        },
        // 删除
        Delete(row) {
            try {
                this.$confirm("确认删除：" + row.UserName + "?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                })
                    .then(() => {
                        this.DeleteUser(row.ID);
                    })
                    .catch(() => {
                    });
            } catch (err) {
                this.$message({
                    message: "服务器开小差了！",
                    type: "error"
                });
            }
        },
        // 删除用户
        async DeleteUser(Id) {
            const { data } = await DeleteOrganUser({ Id: Id });
            if (data.code === 100) {
                this.$message({
                    message: data.msg,
                    type: "success"
                });
                if (this.needToPrePage({
                    page: this.pageIndex,
                    pageSize: this.applyTageSize,
                    total: this.total,
                    delCount: 1
                })) {
                    this.pageIndex--
                }
                this.GetOrganUser();
            } else {
                this.$message({
                    message: data.msg,
                    type: "error"
                });
            }
        },
        // 重置
        Reset(row) {
            try {
                this.$confirm(
                    "确认将用户：" +
                    row.UserName + "密码重置？重置后新密码为：vipzt-667667",
                    "提示",
                    {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                        lockScroll: false
                    }
                )
                    .then(() => {
                        this.ResetPassword(row.ID);
                    })
                    .catch(() => {
                    });
            } catch (err) {
                this.$message({
                    message: "服务器开小差了！",
                    type: "error"
                });
            }
        },

        defaultVal(row, column, cellValue, index) {
            if (cellValue == null || cellValue === "" || cellValue.length === 0 || cellValue === "1753-01-01 00:00:00") {
                return "--"
            } else {
                return cellValue
            }
        },
        // 重置密码
        async ResetPassword(Id) {
            const { data } = await ResetPassword({ Id: Id });
            if (data.code === 100) {
                this.$message({
                    message: data.msg,
                    type: "success"
                });
                await this.GetOrganUser();
            } else {
                this.$message({
                    message: data.msg,
                    type: "error"
                });
            }
        },
        // 用户组选择事件
        organLeverChange(value) {
            this.$set(this.userForm, "OrganLevelId", value)
        },
        // 审核
        AuditPass(row) {
            try {
                this.$confirm(
                    "确认通过用户 [ " + row.UserName + " ] 申请?",
                    "提示",
                    {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                        lockScroll: false
                    }
                )
                    .then(() => {
                        this.AuditUserApplyPass(
                            row.Id,
                            row.ApplyOrganId,
                            row.ApplyGroupId
                        );
                    })
                    .catch(() => {
                    });
            } catch (err) {
                this.$message({
                    message: "服务器开小差了！",
                    type: "error"
                });
            }
        },
        // 审核通过
        async AuditUserApplyPass(applyId, organId, levelId) {
            const { data } = await AuditUserApplyPass({
                applyId: applyId,
                organId: organId,
                levelId: levelId
            });
            if (data.code === 100) {
                this.$message({
                    message: data.msg,
                    type: "success"
                });
                this.GetOrganApplyUser();
            } else {
                this.$message({
                    message: data.msg,
                    type: "error"
                });
            }
        },
        // 审核
        AuditReject(row) {
            try {
                this.$confirm(
                    "确认驳回用户 [ " + row.UserName + " ] 申请?",
                    "提示",
                    {
                        confirmButtonText: "确认",
                        cancelButtonText: "取消",
                        type: "warning",
                        lockScroll: false
                    }
                )
                    .then(() => {
                        this.AuditUserApplyReject(
                            row.Id,
                            row.ApplyOrganId,
                            row.ApplyGroupId
                        );
                    })
                    .catch(() => {
                    });
            } catch (err) {
                this.$message({
                    message: "服务器开小差了！",
                    type: "error"
                });
            }
        },
        // 审核驳回
        async AuditUserApplyReject(applyId, organId, levelId) {
            const { data } = await AuditUserApplyReject({
                applyId: applyId,
                organId: organId,
                levelId: levelId
            });
            if (data.code === 100) {
                this.$message({
                    message: data.msg,
                    type: "success"
                });
                this.GetOrganApplyUser();
            } else {
                this.$message({
                    message: data.msg,
                    type: "error"
                });
            }
        },
        // 关闭弹框
        closeDialog() {
            this.userVisible = false;

            this.userForm = {
                ID: "",
                UserName: "",
                UserPass: "",
                RealName: "",
                Telephone: "",
                Email: "",
                Address: "",
                CardId: "",
                NumberNo: "",
                Flags: 0,
                GroupUserId: "",
                OrganLevelId: 0,
                Balance: 0,
                DescInfo: "",
                UserRoleType: 0,
                UserType: 2,
                ImportFlags: -1
            };
        },

        // 导入用户
        importUser () {
            this.$refs.userDialog.open()
        }
    }
};
</script>

<style scoped lang="less">
.search-container {
    display: flex;
    padding-left: 48px;
    padding-right: 24px;
    box-sizing: border-box;
    margin-bottom: 30px;
    justify-content: space-between;
    align-items: center;
}
.form {
    padding: 20px 48px;

    ::v-deep .el-tabs__header {
        height: 60px;
        line-height: 60px;
    }

    ::v-deep .el-tabs__nav {
        height: 60px;
        line-height: 60px;
    }

    ::v-deep .el-input__inner {
        height: 35px;
    }

    ::v-deep .el-cascader {
        width: 350px;
    }
}

.form2 {
    padding: 20px 48px;

    ::v-deep .el-input__inner {
        height: 35px;
    }
}

.table {
    padding: 0 48px 48px 48px;

    .table-btn {
        margin-left: 5px;
    }

    .table-btn2 {
        margin-top: 5px;
    }
}

.exam-list {
    width: 100%;

    ::v-deep.operation {
        button {
            margin-top: 10px;
        }
    }

    .info {
        margin-left: 30px;
    }

    .dialog-span {
        text-align: right;
        padding-right: 15px;
    }
}

.fromflexbox {
    display: flex;
}

::v-deep .el-dialog__body {
    .dialog-text {
        width: 250px;
    }

}
</style>
